import TextField from '@/components/FormElements/TextField';
import { DOMAIN_NAME, dybrConfigs } from '@/configs/dybr';
import * as React from 'react';

interface BlogSlugFieldProps {
  slug: string;
  setSlug: (value: string) => void;
  errorSlug: string;
  setErrorSlug: (value: string) => void;
  validate: () => void;
}

function BlogSlugField({
  slug,
  setSlug,
  errorSlug,
  setErrorSlug,
  validate
}: BlogSlugFieldProps) {
  return (
    <div style={{ display: 'flex', marginBottom: '20px' }}>
      <div
        style={{
          flexGrow: '0',
          fontWeight: 'bold',
          position: 'relative',
          top: '19px',
          left: '2px'
        }}
      >
        {DOMAIN_NAME}/blog/
      </div>
      <div style={{ flexGrow: '4' }}>
        <TextField
          id="slug"
          type="text"
          value={slug}
          meta={{}}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSlug(e.target.value);
            setErrorSlug('');
          }}
          className=""
          label="короткий адрес дневника"
          maxLen={dybrConfigs.MAX_LENGTH.blogSlug}
          onBlur={validate}
          error={errorSlug}
          touched={Boolean(errorSlug)}
        />
      </div>
    </div>
  );
}

export default BlogSlugField;
